import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { UPDATE_STAFF_INFO_BY_STAFF_ID } from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

export const useStaffForm = () => {

  const staffInfo = useSelector(state => state.staffInfoReducer.staffInfo)
  const [staffInfoError, setStaffInfoError] = useState({})

  const [updateStaffInfoByStaffId, { loading: updateStaffInfoLoading }] = useMutation(
    UPDATE_STAFF_INFO_BY_STAFF_ID,
    {
      onCompleted: (updateStaffInfoData)=> {
        if(updateStaffInfoData?.updateStaff?.id) {
          message.success('Staff Info updated successfully!')  
        } else {
          const content = 'Update failed'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  //function for valid form, make sure nonempty field in the form
  const isValidForm = () => {

    let result = true
    if (!staffInfo.streetAddress) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressError: false}))
    }

    if (!staffInfo.fullName) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, fullNameError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, fullNameError: false}))
    }

    if (!staffInfo.email) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, emailError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, emailError: false}))
    }

    if (!staffInfo.phoneNumber) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, phoneNumberError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, phoneNumberError: false}))
    }

    if (!staffInfo.staffRoleIds?.length) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, rolesError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, rolesError: false}))
    }

    if(staffInfo.PIN && staffInfo.PIN.length !== 6) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, passwordError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, passwordError: false}))
    }

    return result
  }

  const updateStaffInfo = () => {

    if (isValidForm()) {
      const updateStaffInput = {}
      updateStaffInput.fullName = staffInfo.fullName
      updateStaffInput.email = staffInfo.email
      updateStaffInput.phoneNumber = staffInfo.phoneNumber 
      updateStaffInput.address = staffInfo.streetAddress
      updateStaffInput.addressLine2 = staffInfo.streetAddressLine2 || ""
      updateStaffInput.city = staffInfo.city || ""
      updateStaffInput.province = staffInfo.province || ""
      updateStaffInput.postalCode = staffInfo.postalCode || ""
      updateStaffInput.country = staffInfo.country || ""
      updateStaffInput.isActive = staffInfo.isActive
      updateStaffInput.staffRoleIds = staffInfo.staffRoleIds
      if(staffInfo.PIN?.length===6) {
        updateStaffInput.pin = staffInfo.PIN
      }

      updateStaffInfoByStaffId({
        variables: {
          staffId: staffInfo.staffId,
          input: updateStaffInput
        }
      }) 
    } else {
      const content = 'Please fill the form!'
      debouncedErrorMessage(content);
    }
  };

  return {
    updateStaffInfo,
    updateStaffInfoLoading,
    staffInfoError,
    setStaffInfoError
  }
}
